<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 15:38:18
 * @LastEditTime: 2020-05-25 15:46:58
 * @Description: 添加题目步骤
 -->
<template>
  <div class="add-question-by-product-group-step">
    <i-steps :current="current">
      <i-step title="筛选试题"></i-step>
      <i-step title="添加试题"></i-step>
    </i-steps>
  </div>
</template>

<script>
export default {
  name: 'AddQuestionByProductGroupStep',
  props: {
    current: { type: Number, required: true },
  },
};
</script>

<style lang="less" scoped>
.add-question-by-product-group-step {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 36px 0;

  /deep/ .ivu-steps {
    width: 60%;
  }
}
</style>
